/** manner_temperature tier boundaries — keep in sync with ActivityScoreBadge. */
export const MINGO_BIRD_TIERS = [
  { min: 91, id: 'golden', label: '골든밍고' },
  { min: 71, id: 'rainbow', label: '무지개밍고' },
  { min: 51, id: 'bird', label: '밍고' },
  { min: 37, id: 'hatchling', label: '아기밍고' },
  { min: -Infinity, id: 'egg', label: '밍고알' },
];

/** @param {number} score */
export function resolveTierIndex(score) {
  const numeric = Number.isFinite(score) ? score : 0;
  const idx = MINGO_BIRD_TIERS.findIndex((tier) => numeric >= tier.min);
  return idx === -1 ? MINGO_BIRD_TIERS.length - 1 : idx;
}

/** @param {number} score */
export function resolveTierId(score) {
  return MINGO_BIRD_TIERS[resolveTierIndex(score)].id;
}
